const q=(selector,scope=document)=>scope.querySelector(selector);
const qa=(selector,scope=document)=>[...scope.querySelectorAll(selector)];
const root=q('[data-cart-page]');

if(root){
  let currency=root.dataset.cartCurrency||window.Shopify?.currency?.active||'AUD';
  const locale=document.documentElement.lang||'en-AU';
  const money=cents=>{
    if(window.PDCart?.money)return window.PDCart.money(cents);
    try{return new Intl.NumberFormat(locale,{style:'currency',currency}).format((Number(cents)||0)/100)}
    catch(_error){return `${((Number(cents)||0)/100).toFixed(2)} ${currency}`}
  };
  const route=path=>`${window.Shopify?.routes?.root||'/'}${path}`;
  let changing=false;

  function setStatus(message=''){
    const status=q('[data-cart-page-status]',root);
    if(status)status.textContent=message;
  }

  function setLineError(row,message=''){
    const error=q('[data-cart-line-error]',row);
    if(error)error.textContent=message;
  }

  function updateDiscounts(list,allocations=[]){
    if(!list)return;
    allocations=allocations.filter(allocation=>Number(allocation.amount)>0);
    list.replaceChildren();
    allocations.forEach(allocation=>{
      const item=document.createElement('li');
      item.textContent=`${allocation.discount_application?.title||'Discount'} (-${money(allocation.amount)})`;
      list.append(item);
    });
    list.hidden=allocations.length===0;
  }

  async function refreshMarkup(){
    const note=q('[name="note"]',root)?.value;
    const response=await fetch(`${route('cart')}?section_id=${encodeURIComponent(root.dataset.cartSection)}`,{headers:{Accept:'text/html'},signal:AbortSignal.timeout(15000)});
    if(!response.ok)throw new Error('Cart refresh failed');
    const fresh=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-cart-page]');
    if(!fresh)throw new Error('Cart refresh failed');
    root.replaceChildren(...fresh.childNodes);
    if(note!==undefined&&q('[name="note"]',root))q('[name="note"]',root).value=note;
  }
  async function renderCart(cart){
    const existing=qa('[data-cart-page-line]',root);
    // Discounts can split/reorder lines or change keys. Never relabel old photo DOM by index.
    if(existing.length!==cart.items.length||existing.some((row,index)=>row.dataset.cartLineKey!==cart.items[index]?.key))await refreshMarkup();
    currency=cart.currency||currency;
    qa('[data-cart-count]').forEach(count=>{
      count.textContent=cart.item_count;
      count.hidden=cart.item_count===0;
    });

    const count=q('[data-cart-page-count]',root);
    if(count){
      count.textContent=`${cart.item_count} ${cart.item_count===1?'item':'items'}`;
      count.hidden=cart.item_count===0;
    }

    const rows=qa('[data-cart-page-line]',root);
    rows.forEach((row,index)=>{
      const item=cart.items[index];
      if(!item){row.remove();return}
      row.dataset.cartLineKey=item.key;
      row.dataset.cartLineIndex=String(index+1);
      row.removeAttribute('aria-busy');
      qa('button,input',row).forEach(control=>{control.disabled=false});
      const input=q('[data-cart-page-input]',row);
      if(input){
        input.value=item.quantity;
        input.name=`updates[${item.key}]`;
        input.dataset.cartQuantity=String(item.quantity);
      }
      const price=q('[data-cart-line-price]',row);
      if(price){
        const finalPrice=q('strong',price);
        const originalPrice=q('s',price);
        if(finalPrice){
          finalPrice.textContent=money(item.final_line_price);
          const interval=window.PDCart?.sellingPlanInterval(item.selling_plan_allocation?.selling_plan);
          if(interval){const frequency=document.createElement('small');frequency.className='cart-line__price-frequency';frequency.textContent=` / ${interval}`;finalPrice.append(frequency)}
        }
        if(originalPrice){
          originalPrice.textContent=money(item.original_line_price);
          originalPrice.hidden=item.original_line_price<=item.final_line_price;
        }
      }
      updateDiscounts(q('[data-cart-line-discounts]',row),item.line_level_discount_allocations);
      setLineError(row);
    });

    const discountBox=q('[data-cart-summary-discounts]',root);
    const discountValue=q('[data-cart-summary-discount]',root);
    if(discountBox)discountBox.hidden=!cart.total_discount;
    if(discountValue)discountValue.textContent=`-${money(cart.total_discount)}`;
    const total=q('[data-cart-page-total]',root);
    if(total)total.textContent=money(cart.total_price);

    const isEmpty=cart.item_count===0;
    const empty=q('[data-cart-page-empty]',root);
    const populated=q('[data-cart-page-populated]',root);
    if(empty)empty.hidden=!isEmpty;
    if(populated)populated.hidden=isEmpty;
    setStatus();
    document.dispatchEvent(new CustomEvent('pd:cart:updated',{detail:cart}));
  }

  async function changeQuantity(row,quantity){
    if(changing)return;
    changing=true;root.setAttribute('aria-busy','true');
    const input=q('[data-cart-page-input]',row);
    const previous=Number(input?.dataset.cartQuantity)||1;
    const safeQuantity=Math.max(0,Number(quantity)||0);
    row.setAttribute('aria-busy','true');
    qa('button,input',row).forEach(control=>{control.disabled=true});
    setLineError(row);
    setStatus();
    try{
      const freshResponse=await fetch(route('cart.js'),{headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});
      if(!freshResponse.ok)throw new Error('Cart read failed');
      const freshCart=await freshResponse.json();
      if(!freshCart.items.some(item=>item.key===row.dataset.cartLineKey)){await refreshMarkup();setStatus('Your cart changed. Please review the refreshed items and try again.');return}
      const response=await fetch(route('cart/change.js'),{
        method:'POST',
        signal:AbortSignal.timeout(15000),
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:row.dataset.cartLineKey,quantity:safeQuantity})
      });
      if(!response.ok)throw new Error('Cart update failed');
      const cart=await response.json();
      await renderCart(cart);
    }catch(_error){
      try{await refreshMarkup()}catch{}
      row.removeAttribute('aria-busy');
      qa('button,input',row).forEach(control=>{control.disabled=false});
      if(input)input.value=previous;
      setLineError(row,'We could not update this item. Please try again.');
      setStatus('Please refresh your cart to confirm the current items before trying again.');
    }finally{
      changing=false;root.removeAttribute('aria-busy');
    }
  }

  root.addEventListener('click',event=>{
    const quantityButton=event.target.closest('[data-cart-page-quantity]');
    const removeButton=event.target.closest('[data-cart-page-remove]');
    const control=quantityButton||removeButton;
    if(!control)return;
    const row=control.closest('[data-cart-page-line]');
    const input=q('[data-cart-page-input]',row);
    if(!row||!input)return;
    if(removeButton){changeQuantity(row,0);return}
    const adjustment=quantityButton.dataset.cartPageQuantity==='increase'?1:-1;
    changeQuantity(row,Math.max(0,(Number(input.value)||0)+adjustment));
  });

  root.addEventListener('change',event=>{
    const input=event.target.closest('[data-cart-page-input]');
    if(!input)return;
    const row=input.closest('[data-cart-page-line]');
    changeQuantity(row,Math.max(0,Number(input.value)||0));
  });
  root.addEventListener('submit',event=>{if(changing){event.preventDefault();setStatus('Please wait for the cart update to finish.')}});
}
